import { secondsLeft, useWallClock } from '../components/useNow.js';
import { useApp } from '../store.js';

/** Поиск соперников: кто уже в турнире и через сколько боты займут свободные места. */
export function Search() {
  const t = useApp((s) => s.tournament);
  const leave = useApp((s) => s.leaveTournament);
  const offset = useApp((s) => s.clockOffset);
  const now = useWallClock();
  if (!t) return null;
  const left = t.fillAt ? Math.ceil(secondsLeft(t.fillAt, offset, now || t.serverTime - offset)) : 0;
  const humans = t.players.length;
  const quick = t.kind === 'QUICK';
  return (
    <main className="screen search">
      <div className="search__spinner" aria-hidden="true">
        ⚽
      </div>
      <h1 className="screen__title">{quick ? 'Ищем соперника' : `Собираем турнир на ${t.size}`}</h1>
      <p className="screen__lead">
        {quick
          ? left > 0
            ? `1 на 1 без билета · если никого не найдём за ${left} с — сыграете с ботом`
            : 'Подбираем бота'
          : `Игроков: ${humans} из ${t.size}${left > 0 ? ` · через ${left} с свободные места займут боты` : ' · добираем ботов'}`}
      </p>
      {!quick && <p className="field__hint">Вышли до старта — билет вернётся</p>}
      <ol className="search__slots">
        {Array.from({ length: t.size }, (_, i) => {
          const p = t.players[i];
          return (
            <li
              key={i}
              className={`search__slot ${p ? 'search__slot--taken' : ''} ${p?.isYou ? 'search__slot--you' : ''}`}
            >
              {p ? (p.isYou ? 'Вы' : p.name) : '…'}
            </li>
          );
        })}
      </ol>
      <button type="button" className="link" onClick={() => void leave()}>
        Выйти из поиска
      </button>
    </main>
  );
}
